import { WorkflowModel } from '@models/workflow.model';
import { DatasetTableAction, DatasetTableConfig, dateColumn, TableConfigBuilder, textColumn } from '@ui';

export interface WorkflowRunItemRow extends WorkflowModel.WorkflowRunSummaryItem {
    statusLabel: string;
};

export interface createRunListTableConfigDependencies {
    onRowClick: (row: WorkflowRunItemRow) => void;
}

const cancelAction: DatasetTableAction<WorkflowRunItemRow> = {
    id: 'cancelRun',
    icon: 'ui-icon-close',
    tooltip: 'FLOW_CHART.RUN_LIST_TABLE.CANCEL_RUN',
    tooltipClass: 'sidebar-tooltip',
    showInline: true,
    visible: (row) => row.status === WorkflowModel.RunStatus.Running,
};

const viewJsonOutput: DatasetTableAction<WorkflowRunItemRow> = {
    id: 'viewJsonOutput',
    icon: 'ui-icon-output',
    tooltip: 'FLOW_CHART.RUN_LIST_TABLE.VIEW_JSON_OUTPUT',
    tooltipClass: 'sidebar-tooltip',
    showInline: true,
    visible: (row) => !!row.output,
};

export function createRunListTableConfig(
    dependencies: createRunListTableConfigDependencies,
): DatasetTableConfig<WorkflowRunItemRow> {
    return new TableConfigBuilder<WorkflowRunItemRow>()
        .columns([
            textColumn<WorkflowRunItemRow>('runId', 'FLOW_CHART.RUN_LIST_TABLE.RUN_ID', {
                width: 'minmax(150px, 1fr)',
                mobileVisible: true,
            }),
            textColumn<WorkflowRunItemRow>('statusLabel', 'FLOW_CHART.RUN_LIST_TABLE.STATUS', {
                width: 'minmax(150px, 1fr)',
                mobileVisible: true,
            }),
            dateColumn<WorkflowRunItemRow>('startedAt', 'FLOW_CHART.RUN_LIST_TABLE.STARTED_AT', {
                width: 'minmax(180px, 1fr)',
                customFormat: 'YYYY MMM DD, hh:mm A',
                showTimeZone: true,
                mobileVisible: true,
            }),
            dateColumn<WorkflowRunItemRow>('endedAt', 'FLOW_CHART.RUN_LIST_TABLE.ENDED_AT', {
                width: 'minmax(180px, 1fr)',
                customFormat: 'YYYY MMM DD, hh:mm A',
                showTimeZone: true,
                mobileVisible: true,
            }),
            textColumn<WorkflowRunItemRow>('durationMs', 'FLOW_CHART.RUN_LIST_TABLE.DURATION', {
                width: 'minmax(150px, 1fr)',
                mobileVisible: true,
            }),
        ])
        .actions([
            cancelAction,
            viewJsonOutput,
        ])
        .onRowClick((row) => dependencies.onRowClick(row))
        .trackBy('runId')
        .rowHeight(52)
        .build();
}
